import image from "../img/studio-augus-interior.jpg";


export default function Hero() {
  return (
      <div className="hero" style={{ backgroundImage:`url(${image})` }}></div>
  );
}
